import React from "react";
import "./salaryPreviewPopup.scss";

const SalaryOfferPreviewPopup = ({ show, onClose, data }) => {
  if (!show) return null;

  const format = (val) => `₹ ${val ?? 0}`;
  const shouldShow = (m, y) => Number(m) !== 0 || Number(y) !== 0;

  return (
    <div className="SalaryPreviewScreen">
      <div className="SalaryPreviewWrapper">
        <div className="SalaryPreviewCard">
          {/* Header */}
          <div className="headerPreview">
            <h5>Salary Preview</h5>
            <button onClick={onClose}>✕</button>
          </div>

          {/* Table */}
          <div className="tableWrapper">
            <table>
              <thead>
                <tr>
                  <th>Component</th>
                  <th>Monthly</th>
                  <th>Yearly</th>
                </tr>
              </thead>

              <tbody>
                {/* ================= EARNINGS ================= */}
                <tr className="section">
                  <td colSpan={3}>Earning Breakup</td>
                </tr>

                {shouldShow(data.basic_salary, data.basic_salary_yearly) && (
                  <tr>
                    <td>Basic</td>
                    <td>{format(data.basic_salary)}</td>
                    <td>{format(data.basic_salary_yearly)}</td>
                  </tr>
                )}

                {shouldShow(data.hra_salary, data.hra_salary_yearly) && (
                  <tr>
                    <td>HRA</td>
                    <td>{format(data.hra_salary)}</td>
                    <td>{format(data.hra_salary_yearly)}</td>
                  </tr>
                )}

                {shouldShow(data.ca_salary, data.ca_salary_yearly) && (
                  <tr>
                    <td>Conveyance Allowance</td>
                    <td>{format(data.ca_salary)}</td>
                    <td>{format(data.ca_salary_yearly)}</td>
                  </tr>
                )}

                {shouldShow(
                  data.stationary_bonus,
                  data.stationary_bonus_yearly,
                ) && (
                    <tr>
                      <td>Statutory Bonus</td>
                      <td>{format(data.stationary_bonus)}</td>
                      <td>{format(data.stationary_bonus_yearly)}</td>
                    </tr>
                  )}

                <tr className="highlight">
                  <td>Gross Salary</td>
                  <td>{format(data.gross_salary)}</td>
                  <td>{format(data.gross_salary_yearly)}</td>
                </tr>

                {shouldShow(
                  data.variable_salary,
                  data.variable_salary_yearly,
                ) && (
                    <tr>
                      <td>Variable Salary</td>
                      <td>{format(data.variable_salary)}</td>
                      <td>{format(data.variable_salary_yearly)}</td>
                    </tr>
                  )}

                {/* ================= EMPLOYEE ================= */}
                <tr className="section">
                  <td colSpan={3}>Employee Deductions</td>
                </tr>

                {shouldShow(data.pf_1, data.pf_1_yearly) && (
                  <tr>
                    <td>PF Emp. Contri.</td>
                    <td>{format(data.pf_1)}</td>
                    <td>{format(data.pf_1_yearly)}</td>
                  </tr>
                )}

                {shouldShow(data.esi_1, data.esi_1_yearly) && (
                  <tr>
                    <td>ESI Emp. Contri.</td>
                    <td>{format(data.esi_1)}</td>
                    <td>{format(data.esi_1_yearly)}</td>
                  </tr>
                )}

                {shouldShow(
                  data.professional_tax,
                  data.professional_tax_yearly,
                ) && (
                    <tr>
                      <td>Professional Tax</td>
                      <td>{format(data.professional_tax)}</td>
                      <td>{format(data.professional_tax_yearly)}</td>
                    </tr>
                  )}

                {shouldShow(data.lwf_employee, data.lwf_employee_yearly) && (
                  <tr>
                    <td>LWF (Employee)</td>
                    <td>{format(data.lwf_employee)}</td>
                    <td>{format(data.lwf_employee_yearly)}</td>
                  </tr>
                )}

                <tr className="highlight">
                  <td>Total Deduction</td>
                  <td>{format(data.employee_deduction)}</td>
                  <td>{format(data.employee_deduction_yearly)}</td>
                </tr>

                <tr className="highlight">
                  <td>In Hand (Pre-Tax)</td>
                  <td>{format(data.inhand_pertax)}</td>
                  <td>{format(data.inhand_pertax_yearly)}</td>
                </tr>

                {/* ================= COMPANY ================= */}
                <tr className="section">
                  <td colSpan={3}>Company Contribution</td>
                </tr>

                {shouldShow(data.pf_2, data.pf_2_yearly) && (
                  <tr>
                    <td>PF Comp. Contri.</td>
                    <td>{format(data.pf_2)}</td>
                    <td>{format(data.pf_2_yearly)}</td>
                  </tr>
                )}

                {shouldShow(data.esi_2, data.esi_2_yearly) && (
                  <tr>
                    <td>ESI Comp. Contri.</td>
                    <td>{format(data.esi_2)}</td>
                    <td>{format(data.esi_2_yearly)}</td>
                  </tr>
                )}

                {shouldShow(data.gratuity, data.gratuity_yearly) && (
                  <tr>
                    <td>Gratuity</td>
                    <td>{format(data.gratuity)}</td>
                    <td>{format(data.gratuity_yearly)}</td>
                  </tr>
                )}

                {shouldShow(data.pf_exp, data.pf_exp_yearly) && (
                  <tr>
                    <td>PF Expense</td>
                    <td>{format(data.pf_exp)}</td>
                    <td>{format(data.pf_exp_yearly)}</td>
                  </tr>
                )}
                {shouldShow(data.lwf_employer, data.lwf_employer_yearly) && (
                  <tr>
                    <td>LWF (Employer)</td>
                    <td>{format(data.lwf_employer)}</td>
                    <td>{format(data.lwf_employer_yearly)}</td>
                  </tr>
                )}

                {/* {shouldShow(
                  data.medical_insurance,
                  data.medical_insurance_yearly,
                ) && (
                  <tr>
                    <td>Medical Insurance</td>
                    <td>{format(data.medical_insurance)}</td>
                    <td>{format(data.medical_insurance_yearly)}</td>
                  </tr>
                )}

                {shouldShow(
                  data.accident_insurance,
                  data.accident_insurance_yearly,
                ) && (
                  <tr>
                    <td>Accident Insurance</td>
                    <td>{format(data.accident_insurance)}</td>
                    <td>{format(data.accident_insurance_yearly)}</td>
                  </tr>
                )}

                <tr className="highlight">
                  <td>Total Contribution</td>
                  <td>{format(data.company_contribution)}</td>
                  <td>{format(data.company_contribution_yearly)}</td>
                </tr> */}
                {shouldShow(
                  data.premium_insurance,
                  data.premium_insurance_yearly,
                ) && (
                    <tr>
                      <td>Premium Insurance</td>
                      <td>{format(data.premium_insurance)}</td>
                      <td>{format(data.premium_insurance_yearly)}</td>
                    </tr>
                  )}

                <tr className="highlight">
                  <td>Total Contribution</td>
                  <td>{format(data.company_contribution)}</td>
                  <td>{format(data.company_contribution_yearly)}</td>
                </tr>

                {/* ================= REIMBURSEMENTS ================= */}
                {(shouldShow(
                  data.mobile_expenses,
                  data.mobile_expenses_yearly,
                ) ||
                  shouldShow(data.bonus, data.bonus_yearly) ||
                  shouldShow(data.conveyance, data.conveyance_yearly) ||
                  shouldShow(
                    data.reimbursement,
                    data.reimbursement_yearly,
                  )) && (
                    <>
                      <tr className="section">
                        <td colSpan={3}>Reimbursements</td>
                      </tr>

                      {shouldShow(
                        data.mobile_expenses,
                        data.mobile_expenses_yearly,
                      ) && (
                          <tr>
                            <td>Mobile Expenses</td>
                            <td>{format(data.mobile_expenses)}</td>
                            <td>{format(data.mobile_expenses_yearly)}</td>
                          </tr>
                        )}

                      {shouldShow(data.bonus, data.bonus_yearly) && (
                        <tr>
                          <td>Bonus</td>
                          <td>{format(data.bonus)}</td>
                          <td>{format(data.bonus_yearly)}</td>
                        </tr>
                      )}

                      {shouldShow(data.conveyance, data.conveyance_yearly) && (
                        <tr>
                          <td>Conveyance</td>
                          <td>{format(data.conveyance)}</td>
                          <td>{format(data.conveyance_yearly)}</td>
                        </tr>
                      )}

                      {shouldShow(
                        data.reimbursement,
                        data.reimbursement_yearly,
                      ) && (
                          <tr>
                            <td>Other Reimbursement</td>
                            <td>{format(data.reimbursement)}</td>
                            <td>{format(data.reimbursement_yearly)}</td>
                          </tr>
                        )}
                    </>
                  )}

                {/* ================= FINAL CTC ================= */}
                <tr className="section">
                  <td colSpan={3}>CTC</td>
                </tr>

                <tr className="highlight strong">
                  <td>CTC</td>
                  <td>{format(data.ctc)}</td>
                  <td>{format(data.ctc_yearly)}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Footer */}
          <div className="footer">
            {/* <p>
              <strong>CTC (Yearly in words):</strong>{" "}
              {data.ctc_amount_words_yearly}
            </p> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalaryOfferPreviewPopup;
